module.exports = __webpack_public_path__ + "static/img/s1tit.d1bd12a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/s1tit.png
// module id = aJol
// module chunks = 0